document.addEventListener("DOMContentLoaded", () => {
    function initPagination(blocks) {
        const itemsPerPage = 9;
        const learnMoreGrid = document.querySelector(".learn-more-grid");
        const totalPages = Math.ceil(blocks.length / itemsPerPage);
    
        function renderPage(pageNumber) {
            const startIndex = (pageNumber - 1) * itemsPerPage;
            const endIndex = pageNumber * itemsPerPage;
            const blocksToRender = blocks.slice(startIndex, endIndex);
    
            let html = '';
            blocksToRender.forEach(block => {
                const renderedBlock = `
                    <div class="video" data-video="${block.video}" >
                        <div class="video__content">
                            <div class="video__content-holder"></div>
                            <div class="video__content-btns-image">
                            <svg class="play-btn" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.8">
                                <path d="M76.8818 16.6825C73.9941 13.2497 68.6624 11.8495 58.4803 11.8495H21.519C11.1037 11.8495 5.68181 13.3401 2.8049 16.9948C0 20.5581 0 25.8085 0 33.075V46.9251C0 61.0028 3.328 68.1504 21.519 68.1504H58.4805C67.3104 68.1504 72.2033 66.9148 75.3688 63.8854C78.615 60.7788 80 55.7065 80 46.9251V33.075C80 25.4118 79.783 20.1305 76.8818 16.6825ZM51.3603 41.9122L34.5763 50.6841C34.201 50.8802 33.7907 50.9775 33.3809 50.9775C32.9169 50.9775 32.4539 50.8526 32.0439 50.6043C31.2717 50.1365 30.8003 49.2996 30.8003 48.3968V30.9094C30.8003 30.0082 31.2705 29.1721 32.041 28.7039C32.8119 28.2358 33.7706 28.2038 34.5703 28.6193L51.3543 37.3347C52.2083 37.778 52.7445 38.6596 52.7458 39.6214C52.7468 40.5839 52.2129 41.4668 51.3603 41.9122Z" fill="#F4FFEC"/>
                                </g>
                            </svg>
                            <svg class="icon-video-play-hover" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.8">
                                <path d="M76.8818 16.6825C73.9941 13.2497 68.6624 11.8495 58.4803 11.8495H21.519C11.1037 11.8495 5.68181 13.3401 2.8049 16.9948C0 20.5581 0 25.8085 0 33.075V46.9251C0 61.0028 3.328 68.1504 21.519 68.1504H58.4805C67.3104 68.1504 72.2033 66.9148 75.3688 63.8854C78.615 60.7788 80 55.7065 80 46.9251V33.075C80 25.4118 79.783 20.1305 76.8818 16.6825ZM51.3603 41.9122L34.5763 50.6841C34.201 50.8802 33.7907 50.9775 33.3809 50.9775C32.9169 50.9775 32.4539 50.8526 32.0439 50.6043C31.2717 50.1365 30.8003 49.2996 30.8003 48.3968V30.9094C30.8003 30.0082 31.2705 29.1721 32.041 28.7039C32.8119 28.2358 33.7706 28.2038 34.5703 28.6193L51.3543 37.3347C52.2083 37.778 52.7445 38.6596 52.7458 39.6214C52.7468 40.5839 52.2129 41.4668 51.3603 41.9122Z" fill="#E6902D"/>
                                </g>
                            </svg>
                                ${block.cover ? `<img class="video__cover" src="${block.cover}">` : ''}
                            </div>
                        </div>
                        <div class="video__meta">
                            ${block.subtitle ? `<${block.link ? 'a' : 'div'} href="${block.link}" class="video__subtitle">${block.subtitle}</${block.link ? 'a' : 'div'}>` : ''}
                            ${block.date && block.show_date ? `<div class="video__date">${block.date}</div>` : ''}
                            ${block.text ? `<div class="video__text">${block.text}</div>` : ''}
                        </div>
                    </div>`;
                html += renderedBlock;
            });
    
            learnMoreGrid.innerHTML = html;
            if (document.querySelector(".learn-more-grid .video")){
                document.querySelectorAll(".learn-more-grid .video").forEach( item => {
                    const button = item.querySelector(".video__content-btns-image");
                    button.addEventListener("click", function(){
                        const video = document.createElement('div');
                        const id = item.dataset.video;
                        video.innerHTML = `<iframe class="video__video" width="100%" height="100%" src="https://www.youtube.com/embed/${id}?rel=0&controls=1&showinfo=0&loop=1" rel="0" allow="autoplay" allowfullscreen frameborder="0"></iframe>`;
                        button.style.display = 'none'
                        item.querySelector('.video__content-holder').appendChild(video);
                        setTimeout(function(){
                            item.querySelector('iframe').src += "&autoplay=1";
                        }, 500);
                    });
                })
            }
        }
    

        function createPagination() {
            const paginationContainer = document.createElement("div");
            paginationContainer.className = "pagination-container";
        
            const prevButton = document.createElement("button");
            prevButton.classList.add('prev-btn');
            prevButton.innerHTML = `<svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 7.9425L2.2915 4.5L6 1.0575L4.8583 9.98106e-08L3.93402e-07 4.5L4.8583 9L6 7.9425Z" fill="#44604D"/></svg> Previous`;
            prevButton.addEventListener("click", function() {
                const currentPage = parseInt(paginationContainer.querySelector(".active").textContent);
                if (currentPage > 1) {
                    renderPage(currentPage - 1);
                    updatePagination(currentPage - 1);                            
                }
            });
            
            paginationContainer.appendChild(prevButton);
        
            for (let i = 1; i <= totalPages; i++) {
                const pageButton = document.createElement("button");
                pageButton.className = "import-flex";
                pageButton.textContent = i;
                pageButton.onclick = () => {
                    renderPage(i);
                    updatePagination(i);
                };
                paginationContainer.appendChild(pageButton);
            }
        
            const nextButton = document.createElement("button");
            nextButton.classList.add('next-btn')
            nextButton.innerHTML = `Next <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_4169_6048)"><path d="M6 11.9425L9.7085 8.5L6 5.0575L7.1417 4L12 8.5L7.1417 13L6 11.9425Z" fill="#44604D"/></g><defs><clipPath id="clip0_4169_6048"><rect width="18" height="18" fill="white" transform="translate(0 18) rotate(-90)"/></clipPath></defs></svg>`;
            nextButton.addEventListener("click", function() {
                const currentPage = parseInt(paginationContainer.querySelector(".active").textContent);
                if (currentPage < totalPages) {
                    renderPage(currentPage + 1);
                    updatePagination(currentPage + 1);
                }
            });
            paginationContainer.appendChild(nextButton);
        
            document.querySelector(".learn-more-pag").appendChild(paginationContainer);
        
            function updatePagination(currentPage) {
                const buttons = paginationContainer.querySelectorAll("button:not(:first-child):not(:last-child)");
                buttons.forEach(btn => btn.classList.remove("active"));
            
                // Update visibility of "Previous" and "Next" buttons
                prevButton.style.display = currentPage === 1 ? "none" : "inline-block";
                nextButton.style.display = currentPage === totalPages ? "none" : "inline-block";
            
                let startPage, endPage;
                const numVisiblePages = 5;
            
                if (totalPages <= numVisiblePages) {
                    startPage = 1;
                    endPage = totalPages;
                } else {
                    const midPage = Math.floor(numVisiblePages / 2);
                    if (currentPage <= midPage + 1) {
                        startPage = 1;
                        endPage = numVisiblePages;
                    } else if (currentPage >= totalPages - midPage) {
                        startPage = totalPages - numVisiblePages + 1;
                        endPage = totalPages;
                    } else {
                        startPage = currentPage - midPage;
                        endPage = currentPage + midPage;
                    }
                }
            
                buttons.forEach((btn, index) => {
                    btn.style.display = "none";
                
                    if (index < endPage - startPage) {
                        btn.textContent = startPage + index;
                        btn.disabled = false;
                    } else if (index === endPage - startPage && endPage !== totalPages) {
                        btn.textContent = "...";
                        btn.disabled = true;
                    } else if (index === endPage - startPage + 1 && endPage !== totalPages) {
                        btn.textContent = totalPages;
                        btn.disabled = false;
                    }
                
                    if (parseInt(btn.textContent) === currentPage) {
                        btn.classList.add("active");
                    }
                
                    if (!btn.disabled || btn.textContent === "...") {
                        btn.style.display = "inline-block";
                    }
                
                    // Add this condition to check if the button is disabled or not
                    if (!btn.disabled) {
                        btn.onclick = () => {
                            renderPage(parseInt(btn.textContent));
                            updatePagination(parseInt(btn.textContent));
                        };
                    }
                });
                
            }
            
            
            
        
            updatePagination(1);
        }
        
    
        renderPage(1);
        createPagination();
    }    
    initPagination(blocks);
})
